import { render, staticRenderFns } from "./DiscountIndex.vue?vue&type=template&id=2fd9e26a"
import script from "./DiscountIndex.vue?vue&type=script&lang=ts"
export * from "./DiscountIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports